import React from 'react';
import LabelWithInfo from 'modules/shared/components/label-with-info';
import t from 'utils/translate';
import { selectCompanySettings, selectDataLoaded } from 'modules/settings/stores/company-settings-slice-handler';
import {
    selectCallFwdDialogOpen,
    selectSettingsJson,
    toggleCallFwdDialogOpen,
    updateJsonSetting,
} from 'modules/settings/stores/user-settings-slice-handler';
import { useSelector } from 'react-redux';
import ActiveInactiveSelector from './active-inactive-selector';
import Button from '@mui/material/Button';
import CallForwardingDialog from './call-forwarding-dialog';

function SectionAdvancedTelephony() {
    const dataLoaded = useSelector(selectDataLoaded);
    /**
     * @type {CompanySettings}
     */
    const companySettings = useSelector(selectCompanySettings);
    /**
     * @type {UserSettingsJson}
     */
    const settingsJson = useSelector(selectSettingsJson);

    const callFwdDialogOpen = useSelector(selectCallFwdDialogOpen);

    if (!dataLoaded) {
        return '';
    }

    // no call features to display
    if (!companySettings.AllowCallForwarding && !companySettings.AllowCallOut) {
        return;
    }

    return (
        <div className="settings-section" data-test-id="advanced-telephony">
            <div className="settings-section-title">
                <LabelWithInfo text={t('settings_advanced_telephony')} />
                <div className="strike" />
            </div>
            <div className={'section-content'}>
                {companySettings.AllowCallOut && (
                    <div className="section-row" data-test-id={`anonymous-call-out`}>
                        <LabelWithInfo
                            text={t('settings_anonymous_call_out')}
                            info={t('settings_anonymous_call_out_tooltip')}
                            tooltipPlacement="right"
                        />
                        <ActiveInactiveSelector
                            initialValue={settingsJson.anonymousCallOut}
                            onChange={(v) => {
                                updateJsonSetting(
                                    'anonymousCallOut',
                                    v,
                                    t('settings_advanced_telephony'),
                                    t('js_all_anonymous_call_out_changed_successfully'),
                                );
                            }}
                        ></ActiveInactiveSelector>
                    </div>
                )}
                {companySettings.AllowCallForwarding && (
                    <>
                        <div className="section-row" data-test-id={`call-forward`}>
                            <LabelWithInfo
                                text={t('settings_call_forward')}
                                info={t('settings_call_forward_settings_tooltip')}
                                tooltipPlacement="right"
                            />
                            <Button variant="contained" role="primary" onClick={() => toggleCallFwdDialogOpen(true)}>
                                {companySettings.CanChangeCallForwardingSettings
                                    ? t('settings_title')
                                    : t('settings_view_button')}
                            </Button>
                        </div>
                        {callFwdDialogOpen && <CallForwardingDialog />}
                    </>
                )}
            </div>
        </div>
    );
}
export default SectionAdvancedTelephony;
